<template>
    <v-tooltip location="bottom" :disabled="!hasTooltip">
        <template #activator="{ props }">
            <v-btn-icon
                class="align-end"
                v-bind="props"
                @click="emitAuditCheckAlertButtonClicked"
                data-cy="AuditCheckAlertButton_Button_Click"
            >
                <v-badge
                    v-if="count"
                    color="red"
                    :content="count"
                    data-cy="AuditCheckAlertButton_Badge"
                >
                    <v-icon class="pb-1" color="primary" size="x-large"> $oss-warning </v-icon>
                </v-badge>
                <template v-else>
                    <v-icon class="pb-1" color="primary" size="x-large"> $oss-warning </v-icon>
                </template>
            </v-btn-icon>
        </template>
        <span data-cy="AuditCheckAlertButton_Tooltip">{{ tooltipMessage }}</span>
    </v-tooltip>
</template>

<script lang="ts">
import { Component, toNative, Prop, Vue } from "vue-facing-decorator";

/**
 * Component for displaying the number of audit check items.
 */
@Component({
    emits: ["auditCheckAlertButtonClicked"],
})
export class AuditCheckAlertButton extends Vue {
    /**
     * Count displayed in the badge.
     * Optional: if not provided, the badge is not displayed.
     */
    @Prop({ default: 0, required: false }) readonly count: number;

    /**
     * Type of audit check. Used to determine the tooltip message.
     * Optional: if not provided, the tooltip is not displayed.
     */
    @Prop({ default: null, required: false }) readonly auditCheckType: "Bank" | "Document" | null;

    /**
     * List of bank account names with unreconciled balances.
     */
    @Prop({ default: null, required: false }) readonly unreconciledBalancesAccountNames: string[];

    /**
     * Indicates if the tooltip should be displayed.
     */
    hasTooltip = true;

    /**
     * Emits the audit check alert button clicked event.
     */
    emitAuditCheckAlertButtonClicked(): void {
        this.$emit("auditCheckAlertButtonClicked");
    }

    /**
     * Gets the tooltip message based on the audit check type.
     */
    get tooltipMessage(): string {
        switch (this.auditCheckType) {
            case "Bank":
                this.hasTooltip = true;
                if (this.unreconciledBalancesAccountNames?.length) {
                    return `Ecart de trésorerie pour : ${this.unreconciledBalancesAccountNames.join(", ")}`;
                }
                return "Ecart entre le solde de trésorerie et la comptabilité";
            case "Document":
                this.hasTooltip = true;
                return this.$t("audit.CheckDocumentAnomaly.countMessage", {
                    count: this.count,
                });
            default:
                this.hasTooltip = false;
                return "";
        }
    }
}

export default toNative(AuditCheckAlertButton);
</script>
